import { Criterion } from '@/interfaces/criterion';
import { EntityResource } from './entity.resource';

/**
 * Resource kryteriów
 *
 * @export
 * @class CriterionResource
 * @extends {EntityResource<Criterion>}
 */
export class CriterionResource extends EntityResource<Criterion> {
  public listVariables = { filters: 'CriterionFilters' };

  public getFields = {
    id: true,
    name: true,
    type: true,
    validate: true,
    description: true,
    parentId: true,
    calculateType: true,
    maximum: true,
    minimumRequired: true,
    autoFunction: true
  };

  public listFields = {
    id: true,
    name: true,
    type: true,
    validate: true,
    description: true,
    parentId: true,
    maximum: true,
    order: true,
    childrenIds: true,
    stage: {
      id: true,
      name: true
    },
    status: {
      id: true,
      name: true
    },
    formula: true,
    autoFunction: true
  };

  constructor() {
    super({
      entityName: 'criterion'
    });
  }
}

export const criterionResource = new CriterionResource();
